// Author: Kevin Thomas : XKO
// Date: 02/11/04
// JOB 22124

// This file contains barcode check-digit javascript functions for Full ASCII

function ccd_GetFullASCIIchar(intCode) {
  var chrCode, intTmp;

  if (intCode >= 0 && intCode <= 9) chrCode = intCode.toString();
  else if (intCode >= 10 && intCode <= 35) {
    intTmp = intCode - 10 + "A".charCodeAt(0);
    chrCode = String.fromCharCode(intTmp);
  } else if (intCode == 36) chrCode = "-";
  else if (intCode == 37) chrCode = ".";
  else if (intCode == 38) chrCode = " ";
  else if (intCode == 39) chrCode = "$";
  else if (intCode == 40) chrCode = "/";
  else if (intCode == 41) chrCode = "+";
  else if (intCode == 42) chrCode = "%";
  else if (intCode == 43) chrCode = "($)";
  else if (intCode == 44) chrCode = "(%)";
  else if (intCode == 45) chrCode = "(/)";
  else if (intCode == 46) chrCode = "(+)";

  return chrCode;
}

export default ccd_GetFullASCIIchar;
